<p-steps
  [model]="items"
  [activeIndex]="activeIndex"
  [readonly]="readOnly"
  (activeIndexChange)="stepperChanged($event)"
></p-steps>
